define('services/locationService',[
    'lib/knockout',
    'services/apiCore'
], function (
    ko,
    apiCore
) {
    'use strict';

    return {
        /**
         * returns a list of all locations in the organization
         * @param {object} query
         * @returns {object} A promise object to handle the asynchronous response from the server
         */
         getLocations: function(query) {
             return apiCore.v2.get('/locations', query)
                 .then(function (response) {
                     return response.entities;
                 });
         },

         getLocationGuids: function(ids) {
             return apiCore.v2.get(window.location.origin + '/api/v2/locations/bulk/' + ids.join(','), { fl: '*' }).then(function (response) {
                return response.res.map(function(location) {
                    return location._id;
                });
             });
         }
    };
});

